(function carousel($) {
    // More Case Studies section in each case study page only displays 8 random items. So, before Slick library kicks in
    // delete the slide elements.
    var $moreCaseStudies = $('#more-case-studies');
    if ($moreCaseStudies.length > 0) {
        var childCount = $moreCaseStudies.children().length;
        if (childCount <= 0) {
            return;
        }

        var max = childCount - 1,
            randomIndexes = [],
            count = 0,
            val = 0,
            min = 0,
            failsafe=0;

        while (failsafe < 1000 && count < 8) {
            val = Math.floor(Math.random() * (max - min + 1)) + min;
            if (randomIndexes.indexOf(val) === -1) {
                randomIndexes.push(val);
                count ++;
            }

            failsafe++;
        }

        $.each($moreCaseStudies.children(), function(index, value) {
            if (randomIndexes.indexOf(index) === -1) {
                $(value).remove();
            }
        });
    }


    // $('.carousel.case-study__list, .carousel.resource-list').slick({
    $('.carousel.case-study__list').slick({
        dots:   true,
        arrows: true,
        speed:  400,
        slide:  '.carousel__slide',

        slidesToScroll: 3,
        slidesToShow:   3,

        prevArrow: '<button class="carousel__nav-button slick-prev"><span class="sq-icon sq-icon__prev-arrow"></span><span class="visuallyhidden">Previous</span></button>',
        nextArrow: '<button class="carousel__nav-button slick-next"><span class="sq-icon sq-icon__next-arrow"></span><span class="visuallyhidden">Next</span></button>',

        customPaging: function(slider, i) {
            return '<button><span class="visuallyhidden">Scroll to page number </span> ' + (i + 1) + '</button>';
        },

        responsive: [{
            breakpoint: 710,

            settings: {
                slidesToShow:   1,
                slidesToScroll: 0,
                dots:           false,
                arrows:         true,
                centerMode:     true
            }
        }, {
            breakpoint: 1180,

            settings: {
                slidesToShow:   2,
                slidesToScroll: 2,
                dots:           true,
                arrows:         true,
                centerMode:     false
            }
        }]
    });

    $('.carousel.solution__list').slick({
        dots:   true,
        arrows: true,
        speed:  400,
        slide:  '.solution__list-item',

        slidesToScroll: 4,
        slidesToShow:   4,

        prevArrow: '<button class="carousel__nav-button slick-prev"><span class="sq-icon sq-icon__prev-arrow--white"></span><span class="visuallyhidden">Previous</span></button>',
        nextArrow: '<button class="carousel__nav-button slick-next"><span class="sq-icon sq-icon__next-arrow--white"></span><span class="visuallyhidden">Next</span></button>',

        customPaging: function(slider, i) {
            return '<button><span class="visuallyhidden">Scroll to page number </span> ' + (i + 1) + '</button>';
        },

        responsive: [{
            breakpoint: 480,

            settings: {
                slidesToShow:   1,
                slidesToScroll: 1,
                dots:           false,
                arrows:         false,
                centerMode:     true
            }
        }, {
            breakpoint: 1260,

            settings: {
                slidesToShow:   2,
                slidesToScroll: 2,
                dots:           true,
                arrows:         true,
                centerMode:     false
            }
        }]
    });

    $('.carousel.carousel__banner').slick({
        dots:   true,
        arrows: true,
        speed:  800,
        autoplaySpeed: 4500,
        fade: false,
        adaptiveHeight: true,
        slide:  '.carousel__banner-item',

        slidesToScroll: 1,
        slidesToShow:   1,

        prevArrow: '<button class="carousel__nav-button slick-prev"><span class="sq-icon sq-icon__prev-arrow--white"></span><span class="visuallyhidden">Previous</span></button>',
        nextArrow: '<button class="carousel__nav-button slick-next"><span class="sq-icon sq-icon__next-arrow--white"></span><span class="visuallyhidden">Next</span></button>',

    });


}(jQuery));
